export default __webpack_public_path__ + "static/media/482.ea576dec.jpg";